import { DisplayText, Heading, Layout, Page } from '@superops/ui-design-system';
import envConfig from '@nile/home/src/Config/env';
import React from 'react';
import AppHeader from './../../Components/Public/AppHeader';

function ConfirmPage() {
  return (
    <Page fullWidth variant="secondary" contentHeight="100px">
      <div className="Pubilc">
        <AppHeader></AppHeader>
      </div>
      <Layout>
        <Layout.Section>
          <div className="fx col jctr actr g10">
            <Heading element="h1" weight="Bold">
              Confirm your Email
            </Heading>
            <DisplayText size="extraLarge">
              You account has been sucessfully registered. To complete the
              process please check your email for a validation request
            </DisplayText>
            <img
              className="BannerImage pt25"
              src={envConfig.imageRoot + 'svg/inbox-newmail.svg'}
              alt=""
            ></img>
          </div>
        </Layout.Section>
      </Layout>
    </Page>
  );
}

export default ConfirmPage;
